module.exports = __webpack_public_path__ + "static/media/lara.84d415fe.jpg";